/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid200,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid.ts";
import { gradeAndFrequenceViewModelSchema } from "../gradeAndFrequenceViewModelSchema.ts";

export const getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParamsSchema =
  z.object({
    classStudentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid200Schema =
  z.lazy(
    () => gradeAndFrequenceViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500>;

export const getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse>;
